import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-prodcut-delete',
  templateUrl: './prodcut-delete.component.html',
  styleUrls: ['./prodcut-delete.component.css']
})
export class ProdcutDeleteComponent implements OnInit {

  productCompositionData: any = []
  deleteProductCompositionId = ""
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  products:any = []
  uomData: any = []

  constructor( private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    // this.getAllUomMaster()
    // this.generic_service.getProduct().subscribe(
    //   (res:any)=>{
    //     this.products = res.response
    //   }
    // )
    this.getAllProductComposition()
    // this.form = this.fb.group({
    //   productName: [''],
    //   description: [''],
    //   productCompositionIngList:this.fb.array([]),
    // })
    // this.addInfoObject()
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllProductComposition();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllProductComposition();
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllProductComposition(){
    this.generic_service.getAllProductCompositionWithoutPagination().subscribe(
      (res:any)=> {
        console.log(res)
        this.productCompositionData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  deleteUom(id:any){
    this.deleteProductCompositionId = id
  }

  deleteProductComposition(){
    this.generic_service.deleteProductComposition(this.deleteProductCompositionId).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllProductComposition()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }

}

